export default __webpack_public_path__ + "static/media/container.7e7f999b.jpeg";